<template>
<div id="app">
  <v-app id="inspire">
    <v-app-bar
      app
      color="dark"
      dark
    >
    <v-toolbar-title>Graph Layout Labelling</v-toolbar-title>
    <v-spacer></v-spacer>
    <router-link to = "/" tag="button">
    <v-btn
            class="ma-2"
            large
            dark
            >User Login
            <v-icon dark class="ml-3"> mdi-account </v-icon>
    </v-btn>
    </router-link>
    </v-app-bar>
    <v-main>
    <v-card>
    <v-card-actions class="justify-center"> 
    <div class="text-h5 pa-5">Thanks for participating in this project!<br /> 
    We are conducting a research project related to graph drawing.<br />
    We hope you can help us to create a collection of human-preferred graph layouts.<br /> 
    For each graph, you will be asked to choose one drawing you like the most out of 8 drawings.<br /> 
    You will not be assigned a certain number of graphs to label, since we hope you can label as many as you could. <br /> 
    Please take a quick look at the user manual below before you start.</div>
    </v-card-actions>
    </v-card>
    <template>
      <v-carousel height = 880 cycle hide-delimiter-background show-arrows-on-hover interval=10000>
        <v-carousel-item
          v-for="(item,i) in items"
          :key="i"
          v-bind:src="require('@/assets/'+ item.src)"
        ></v-carousel-item>
      </v-carousel>
    </template>
    </v-main>
  </v-app>
</div>
</template>

<script>
export default {
  name:'Instruction',
  title: 'User Instruction',
  data () {
    return {
      items: [
        {
          src: 'heart-manual.png',
        },
        {
          src: 'next-manual.png',
        },
        {
          src: 'back-manual.png',
        },
        {
          src: 'hard-manual.png',
        },
        {
          src: 'statistic-manual.png',
        },
        {
          src: 'quit-manual.png',
        }
      ],
    }
  },
}
</script>
